import { useState } from "react";

export const ESTAFETA_STRINGS = {
  es: {
    appTitle: "Estafeta App",
    loginSubtitle: "Accede con tu token de estafeta",
    tokenPlaceholder: "Pega tu token aqui...",
    enter: "ENTRAR",
    askAdmin: "Pide tu token al administrador del restaurante",
    disabledAccount: "Cuenta desactivada",
    invalidToken: "Token invalido",
    photoTitle: "Foto de entrega",
    retake: "Repetir",
    save: "Guardar",
    takePhoto: "Tomar foto",
    photoSaved: "Foto de entrega guardada!",
    photoError: "Error al subir foto",
    photoRegistered: "Foto de entrega registrada",
    enRoute: "En camino",
    readyStatus: "Listo",
    deliveredStatus: "Entregado",
    moreItems: "mas...",
    pickupBtn: "RECOGER PEDIDO",
    arrivedBtn: "HE LLEGADO",
    arrivedHint: "Avisa al cliente que has llegado",
    deliveredBtn: "ENTREGADO",
    today: "Hoy",
    total: "Total",
    todayEur: "Hoy EUR",
    weekLabel: "Semana",
    weekEur: "Semana EUR",
    totalDeliveries: "Total Entregas",
    totalEur: "Total EUR",
    hideDetails: "Ocultar detalles",
    showDetails: "Ver mas detalles",
    available: "Disponible",
    inRoute: "En ruta",
    orders: "PEDIDOS",
    history: "HISTORIAL",
    noOrders: "Sin pedidos asignados",
    ordersWillAppear: "Los pedidos apareceran aqui automaticamente",
    refresh: "Actualizar",
    noDeliveries: "Sin entregas completadas",
    installApp: "Instalar App",
    installDesc: "Accede mas rapido desde tu pantalla de inicio",
    install: "Instalar",
    appInstalled: "App instalada!",
    newOrder: "Nuevo pedido!",
    newOrdersMsg: "nuevo(s) pedido(s) asignado(s)",
    newOrdersToast: "nuevo(s) pedido(s)!",
    orderPickedUp: "Pedido recogido!",
    orderDelivered: "Pedido entregado!",
    clientNotified: "Cliente notificado! Esperando entrega...",
    error: "Error",
    cash: "Efectivo",
    card: "Tarjeta",
    online: "Online",
    moto: "Moto",
    bicycle: "Bicicleta",
    car: "Auto",
    now: "ahora",
    lang: "ES",
    paymentPaid: "Cliente ya pagó",
    paymentPending: "Pago pendiente",
    paymentCashOnDelivery: "COBRAR EN ENTREGA",
    paymentCardOnDelivery: "PAGO AL RECIBIR",
    needsChange: "NECESITA CAMBIO",
    changeAmount: "Cambio de",
    phonePlaceholder: "Tu numero de WhatsApp...",
    sendCode: "ENVIAR CÓDIGO",
    codePlaceholder: "Código de 6 dígitos",
    verifyCode: "VERIFICAR",
    codeSent: "Código enviado por WhatsApp!",
    notRegistered: "Número no registrado como estafeta",
    codeInvalid: "Código inválido o expirado",
    codeWrong: "Código incorrecto",
    resendCode: "Reenviar código",
    advancedLogin: "Login avanzado (token)",
  },
  pt: {
    appTitle: "App Entregador",
    loginSubtitle: "Acesse com o seu token de entregador",
    tokenPlaceholder: "Cole o seu token aqui...",
    enter: "ENTRAR",
    askAdmin: "Peca o token ao administrador do restaurante",
    disabledAccount: "Conta desativada",
    invalidToken: "Token invalido",
    photoTitle: "Foto da entrega",
    retake: "Repetir",
    save: "Guardar",
    takePhoto: "Tirar foto",
    photoSaved: "Foto da entrega guardada!",
    photoError: "Erro ao enviar foto",
    photoRegistered: "Foto da entrega registada",
    enRoute: "A caminho",
    readyStatus: "Pronto",
    deliveredStatus: "Entregue",
    moreItems: "mais...",
    pickupBtn: "RETIRAR PEDIDO",
    arrivedBtn: "CHEGUEI",
    arrivedHint: "Avisa o cliente que chegaste",
    deliveredBtn: "ENTREGUE",
    today: "Hoje",
    total: "Total",
    todayEur: "Hoje EUR",
    weekLabel: "Semana",
    weekEur: "Semana EUR",
    totalDeliveries: "Total Entregas",
    totalEur: "Total EUR",
    hideDetails: "Ocultar detalhes",
    showDetails: "Ver mais detalhes",
    available: "Disponivel",
    inRoute: "Em rota",
    orders: "PEDIDOS",
    history: "HISTORICO",
    noOrders: "Sem pedidos atribuidos",
    ordersWillAppear: "Os pedidos aparecerao aqui automaticamente",
    refresh: "Atualizar",
    noDeliveries: "Sem entregas concluidas",
    installApp: "Instalar App",
    installDesc: "Acesse mais rapido pelo ecra",
    install: "Instalar",
    appInstalled: "App instalada!",
    newOrder: "Novo pedido!",
    newOrdersMsg: "novo(s) pedido(s) atribuido(s)",
    newOrdersToast: "novo(s) pedido(s)!",
    orderPickedUp: "Pedido retirado!",
    orderDelivered: "Pedido entregue!",
    clientNotified: "Cliente notificado! A aguardar entrega...",
    error: "Erro",
    cash: "Dinheiro",
    card: "Cartao",
    online: "Online",
    moto: "Mota",
    bicycle: "Bicicleta",
    car: "Carro",
    now: "agora",
    lang: "PT",
    paymentPaid: "Cliente já pagou",
    paymentPending: "Pagamento pendente",
    paymentCashOnDelivery: "COBRAR NA ENTREGA",
    paymentCardOnDelivery: "COBRAR COM CARTAO",
    needsChange: "PRECISA DE TROCO",
    changeAmount: "Troco de",
    phonePlaceholder: "O teu numero de WhatsApp...",
    sendCode: "ENVIAR CÓDIGO",
    codePlaceholder: "Código de 6 dígitos",
    verifyCode: "VERIFICAR",
    codeSent: "Código enviado por WhatsApp!",
    notRegistered: "Número não cadastrado como estafeta",
    codeInvalid: "Código inválido ou expirado",
    codeWrong: "Código incorreto",
    resendCode: "Reenviar código",
    advancedLogin: "Login avançado (token)",
  },
};

export default function useEstafetaLang() {
  const [lang, setLangState] = useState(
    () => localStorage.getItem("estafeta_lang") || "es"
  );

  const setLang = (l) => {
    setLangState(l);
    localStorage.setItem("estafeta_lang", l);
  };

  const t = (key) =>
    ESTAFETA_STRINGS[lang]?.[key] || ESTAFETA_STRINGS.es[key] || key;

  return { lang, setLang, t };
}
